var app = angular.module("leonardo");

var TaskDetailDialog = function($scope, $timeout, $filter, TaskService, ApprovalStepService) {
  $scope.task = $scope.ngDialogData.task;
  $scope.mode = $scope.ngDialogData.mode;
  $scope.ismyapproval = $scope.ngDialogData.ismyapproval;
  $scope.taskService = TaskService;
  if ($scope.ngDialogData.task.body) {
    $scope.body = $scope.ngDialogData.task.body.replace(/\n\r?/g, '<br />');
  }
  else {
    $scope.body = '';
  }
  $scope.name = $scope.ngDialogData.task.name;

  $scope.getCurrentStep = function (task) {
    let current_tep = null;
    if (!isEmpty(task.approval_sequences)) {
      angular.forEach(task.approval_sequences, function (sequence) {
        if (sequence.id === task.current_sequence) {
          angular.forEach(sequence.approval_steps, function (step) {
            if (step.status && step.status.toString() === ApprovalStepService.STATUS_IN_PROGRESS) {
              current_tep = step;
            }
          });
        }
      });
    }
    return current_tep;
  };

  $scope.getCurrentStepIndex = function (task) {
    let sequence_steps = 0;
    let current_tep = $scope.getCurrentStep(task);
    if (!isEmpty(task.approval_sequences)) {
      angular.forEach(task.approval_sequences, function (sequence) {
        if (sequence.id === task.current_sequence) {
          sequence_steps = sequence.approval_steps.length;
        }
      });
    }
    return current_tep ? current_tep.index + ' ' + $filter('translate')('of') + ' ' + sequence_steps : ' - ';
  };

  $scope.getCurrentStepDate = function (task) {
    let current_step = $scope.getCurrentStep(task);
    return current_step ? current_step.due_date : task.due_date;
  }

  $scope.resolve = function () {
    $scope.confirm('resolve');
  };

  $scope.isPending = function() {
    var status = $scope.ngDialogData.task && !isNull($scope.ngDialogData.task.status) ?
      $scope.ngDialogData.task.status.toString() : '';
    return status === TaskService.STATUS_PENDING;
  };

  $scope.submit = function() {
    var printContents = angular.element('.ngdialog-content')[0].innerHTML;

    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

    var width;
    var height;
    if (window.innerWidth) {
      width = window.innerWidth;
    }
    else {
      width = document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    }

    if (window.innerHeight) {
      height = window.innerHeight;
    }
    else {
      height = document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    }

    var left = ((width / 2) - (800 / 2)) + dualScreenLeft;
    var top = ((height / 2) - (600 / 2)) + dualScreenTop;

    var popupWin = window.open('', '_blank', 'width=800,height=600,top=' + top + ', left=' + left );
    popupWin.document.open();
    popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="css/style.css"/></head><body onload="window.print()">' + printContents + '</body></html>');
    popupWin.document.close();
    $timeout(function () {
      $scope.$apply(popupWin.close());
    }, 500);
  };
};

app.controller('TaskDetailDialog', ['$scope', '$timeout', '$filter', 'TaskService', 'ApprovalStepService', TaskDetailDialog]);
